import React from 'react';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { ThemedText } from '@/components/themed-text';

interface Props {
  title: string;
  icon: keyof typeof Ionicons.glyphMap;
  children: React.ReactNode;
  /** Ação no canto do cabeçalho (normalmente "Ajustar"). */
  action?: React.ReactNode;
}

const PRIMARY = '#FD5001';

/**
 * A moldura de todo cartão da conversa: o widget é **eco, não formulário**.
 * Ele aparece embaixo da bolha mostrando o que foi entendido — a pergunta
 * continua sendo texto e a resposta também.
 */
export function WidgetCard({ title, icon, children, action }: Props) {
  return (
    <View className="max-w-[92%] gap-3 rounded-2xl border border-border/40 bg-card p-4">
      <View className="flex-row items-center gap-2">
        <View className="h-7 w-7 items-center justify-center rounded-lg bg-primary/10 dark:bg-primary">
          <Ionicons className="text-primary dark:text-white" name={icon} size={14} />
        </View>
        <ThemedText className="flex-1 text-sm font-semibold text-foreground">
          {title}
        </ThemedText>
        {action}
      </View>
      {children}
    </View>
  );
}
